import n, { useState as o } from "react";
import { useIsomorphicEffect as r } from "./index175.mjs";
const i = () => `mantine-${Math.random().toString(36).slice(2, 11)}`, u = n.useId || (() => {
});
function c() {
  const [t, e] = o("");
  return r(() => {
    e(i());
  }, []), t;
}
function s() {
  const t = u();
  return t ? `mantine-${t.replace(/:/g, "")}` : "";
}
function f(t) {
  return typeof t == "string" ? t : s() || c();
}
export {
  f as useId
};
